import React from 'react';
import PropTypes from 'prop-types';

import { mergeClasses } from '@fluentui/react-components';

import { useSimpleCarouselStyles } from './styles';

export const SimpleCarousel = ({
  contents,
}) => {
  const classes = useSimpleCarouselStyles();

  return (
    <div className={mergeClasses('simple-carousel-root', classes.container)}>
      <div className={mergeClasses('simple-carousel-content', classes.cardContents)}>
        {contents}
      </div>
    </div>
  );
};

SimpleCarousel.propTypes = {
  contents: PropTypes.arrayOf(PropTypes.node).isRequired,
};
